export var IconSymbol;
(function (IconSymbol) {
    IconSymbol[IconSymbol["Add"] = 0] = "Add";
    IconSymbol[IconSymbol["Adsr"] = 1] = "Adsr";
    IconSymbol[IconSymbol["ArrowDown"] = 2] = "ArrowDown";
    IconSymbol[IconSymbol["ArrowLeft"] = 3] = "ArrowLeft";
    IconSymbol[IconSymbol["ArrowRight"] = 4] = "ArrowRight";
    IconSymbol[IconSymbol["ArrowUp"] = 5] = "ArrowUp";
    IconSymbol[IconSymbol["AudioBus"] = 6] = "AudioBus";
    IconSymbol[IconSymbol["AudioDevice"] = 7] = "AudioDevice";
    IconSymbol[IconSymbol["AudioFile"] = 8] = "AudioFile";
    IconSymbol[IconSymbol["AutoGain"] = 9] = "AutoGain";
    IconSymbol[IconSymbol["Automation"] = 10] = "Automation";
    IconSymbol[IconSymbol["BassGuitar"] = 11] = "BassGuitar";
    IconSymbol[IconSymbol["Book"] = 12] = "Book";
    IconSymbol[IconSymbol["Box"] = 13] = "Box";
    IconSymbol[IconSymbol["Browse"] = 14] = "Browse";
    IconSymbol[IconSymbol["Bug"] = 15] = "Bug";
    IconSymbol[IconSymbol["Capture"] = 16] = "Capture";
    IconSymbol[IconSymbol["Chain"] = 17] = "Chain";
    IconSymbol[IconSymbol["ChatEmpty"] = 18] = "ChatEmpty";
    IconSymbol[IconSymbol["ChatMessage"] = 19] = "ChatMessage";
    IconSymbol[IconSymbol["Copy"] = 20] = "Copy";
    IconSymbol[IconSymbol["Maximizer"] = 21] = "Maximizer";
    IconSymbol[IconSymbol["Fold"] = 22] = "Fold";
    IconSymbol[IconSymbol["Folder"] = 23] = "Folder";
    IconSymbol[IconSymbol["Charts"] = 24] = "Charts";
    IconSymbol[IconSymbol["Checkbox"] = 25] = "Checkbox";
    IconSymbol[IconSymbol["Clips"] = 26] = "Clips";
    IconSymbol[IconSymbol["Close"] = 27] = "Close";
    IconSymbol[IconSymbol["CloudFolder"] = 28] = "CloudFolder";
    IconSymbol[IconSymbol["Code"] = 29] = "Code";
    IconSymbol[IconSymbol["CollapseDown"] = 30] = "CollapseDown";
    IconSymbol[IconSymbol["Compressor"] = 31] = "Compressor";
    IconSymbol[IconSymbol["Connected"] = 32] = "Connected";
    IconSymbol[IconSymbol["Cube"] = 33] = "Cube";
    IconSymbol[IconSymbol["Cursor"] = 34] = "Cursor";
    IconSymbol[IconSymbol["Curve"] = 35] = "Curve";
    IconSymbol[IconSymbol["Dattorro"] = 36] = "Dattorro";
    IconSymbol[IconSymbol["Delete"] = 37] = "Delete";
    IconSymbol[IconSymbol["Dial"] = 38] = "Dial";
    IconSymbol[IconSymbol["DinSlot"] = 39] = "DinSlot";
    IconSymbol[IconSymbol["Disconnected"] = 40] = "Disconnected";
    IconSymbol[IconSymbol["Divide"] = 41] = "Divide";
    IconSymbol[IconSymbol["DragConnections"] = 42] = "DragConnections";
    IconSymbol[IconSymbol["Dropdown"] = 43] = "Dropdown";
    IconSymbol[IconSymbol["Dropbox"] = 44] = "Dropbox";
    IconSymbol[IconSymbol["DrumSet"] = 45] = "DrumSet";
    IconSymbol[IconSymbol["Tidal"] = 46] = "Tidal";
    IconSymbol[IconSymbol["Duration"] = 47] = "Duration";
    IconSymbol[IconSymbol["EditBox"] = 48] = "EditBox";
    IconSymbol[IconSymbol["Effects"] = 49] = "Effects";
    IconSymbol[IconSymbol["Embed"] = 50] = "Embed";
    IconSymbol[IconSymbol["EQ"] = 51] = "EQ";
    IconSymbol[IconSymbol["Eraser"] = 52] = "Eraser";
    IconSymbol[IconSymbol["Exclude"] = 53] = "Exclude";
    IconSymbol[IconSymbol["Exit"] = 54] = "Exit";
    IconSymbol[IconSymbol["ExpandWidth"] = 55] = "ExpandWidth";
    IconSymbol[IconSymbol["FileList"] = 56] = "FileList";
    IconSymbol[IconSymbol["Film"] = 57] = "Film";
    IconSymbol[IconSymbol["Flask"] = 58] = "Flask";
    IconSymbol[IconSymbol["Focus"] = 59] = "Focus";
    IconSymbol[IconSymbol["Fullscreen"] = 60] = "Fullscreen";
    IconSymbol[IconSymbol["Gate"] = 61] = "Gate";
    IconSymbol[IconSymbol["Generator"] = 62] = "Generator";
    IconSymbol[IconSymbol["GoogleDrive"] = 63] = "GoogleDrive";
    IconSymbol[IconSymbol["Nextcloud"] = 64] = "Nextcloud";
    IconSymbol[IconSymbol["Groove"] = 65] = "Groove";
    IconSymbol[IconSymbol["Guitar"] = 66] = "Guitar";
    IconSymbol[IconSymbol["GuitarTab"] = 67] = "GuitarTab";
    IconSymbol[IconSymbol["Headphone"] = 68] = "Headphone";
    IconSymbol[IconSymbol["Heart"] = 69] = "Heart";
    IconSymbol[IconSymbol["Help"] = 70] = "Help";
    IconSymbol[IconSymbol["HighPass"] = 71] = "HighPass";
    IconSymbol[IconSymbol["HighShelf"] = 72] = "HighShelf";
    IconSymbol[IconSymbol["Insert"] = 73] = "Insert";
    IconSymbol[IconSymbol["InsertDown"] = 74] = "InsertDown";
    IconSymbol[IconSymbol["Invert"] = 75] = "Invert";
    IconSymbol[IconSymbol["Info"] = 76] = "Info";
    IconSymbol[IconSymbol["Lock"] = 77] = "Lock";
    IconSymbol[IconSymbol["Loop"] = 78] = "Loop";
    IconSymbol[IconSymbol["LoopEnd"] = 79] = "LoopEnd";
    IconSymbol[IconSymbol["LoopStart"] = 80] = "LoopStart";
    IconSymbol[IconSymbol["LowPass"] = 81] = "LowPass";
    IconSymbol[IconSymbol["LowShelf"] = 82] = "LowShelf";
    IconSymbol[IconSymbol["Magnet"] = 83] = "Magnet";
    IconSymbol[IconSymbol["MainMenu"] = 84] = "MainMenu";
    IconSymbol[IconSymbol["Maximized"] = 85] = "Maximized";
    IconSymbol[IconSymbol["Menu"] = 86] = "Menu";
    IconSymbol[IconSymbol["Merge"] = 87] = "Merge";
    IconSymbol[IconSymbol["Metronome"] = 88] = "Metronome";
    IconSymbol[IconSymbol["Microphone"] = 89] = "Microphone";
    IconSymbol[IconSymbol["Midi"] = 90] = "Midi";
    IconSymbol[IconSymbol["Minimized"] = 91] = "Minimized";
    IconSymbol[IconSymbol["Mix"] = 92] = "Mix";
    IconSymbol[IconSymbol["Mixing"] = 93] = "Mixing";
    IconSymbol[IconSymbol["Mute"] = 94] = "Mute";
    IconSymbol[IconSymbol["NanoWave"] = 95] = "NanoWave";
    IconSymbol[IconSymbol["NeuralAmp"] = 96] = "NeuralAmp";
    IconSymbol[IconSymbol["New"] = 97] = "New";
    IconSymbol[IconSymbol["NoAudio"] = 98] = "NoAudio";
    IconSymbol[IconSymbol["Note"] = 99] = "Note";
    IconSymbol[IconSymbol["NotePad"] = 100] = "NotePad";
    IconSymbol[IconSymbol["Notification"] = 101] = "Notification";
    IconSymbol[IconSymbol["OpenDAW"] = 102] = "OpenDAW";
    IconSymbol[IconSymbol["Panel"] = 103] = "Panel";
    IconSymbol[IconSymbol["Paste"] = 104] = "Paste";
    IconSymbol[IconSymbol["Peak"] = 105] = "Peak";
    IconSymbol[IconSymbol["Pencil"] = 106] = "Pencil";
    IconSymbol[IconSymbol["Piano"] = 107] = "Piano";
    IconSymbol[IconSymbol["Play"] = 108] = "Play";
    IconSymbol[IconSymbol["Playfield"] = 109] = "Playfield";
    IconSymbol[IconSymbol["PlayOnce"] = 110] = "PlayOnce";
    IconSymbol[IconSymbol["PlayRepeat"] = 111] = "PlayRepeat";
    IconSymbol[IconSymbol["PlayAlternate"] = 112] = "PlayAlternate";
    IconSymbol[IconSymbol["Pointer"] = 113] = "Pointer";
    IconSymbol[IconSymbol["Popout"] = 114] = "Popout";
    IconSymbol[IconSymbol["Primary"] = 115] = "Primary";
    IconSymbol[IconSymbol["Random"] = 116] = "Random";
    IconSymbol[IconSymbol["Record"] = 117] = "Record";
    IconSymbol[IconSymbol["Rectangle"] = 118] = "Rectangle";
    IconSymbol[IconSymbol["Redo"] = 119] = "Redo";
    IconSymbol[IconSymbol["Region"] = 120] = "Region";
    IconSymbol[IconSymbol["Robot"] = 121] = "Robot";
    IconSymbol[IconSymbol["RoundDown"] = 122] = "RoundDown";
    IconSymbol[IconSymbol["RoundUp"] = 123] = "RoundUp";
    IconSymbol[IconSymbol["Run"] = 124] = "Run";
    IconSymbol[IconSymbol["Sawtooth"] = 125] = "Sawtooth";
    IconSymbol[IconSymbol["Saxophone"] = 126] = "Saxophone";
    IconSymbol[IconSymbol["Scissors"] = 127] = "Scissors";
    IconSymbol[IconSymbol["Search"] = 128] = "Search";
    IconSymbol[IconSymbol["Share"] = 129] = "Share";
    IconSymbol[IconSymbol["SelectDown"] = 130] = "SelectDown";
    IconSymbol[IconSymbol["SelectUp"] = 131] = "SelectUp";
    IconSymbol[IconSymbol["Shadertoy"] = 132] = "Shadertoy";
    IconSymbol[IconSymbol["Shutdown"] = 133] = "Shutdown";
    IconSymbol[IconSymbol["Sine"] = 134] = "Sine";
    IconSymbol[IconSymbol["Solo"] = 135] = "Solo";
    IconSymbol[IconSymbol["SoundFont"] = 136] = "SoundFont";
    IconSymbol[IconSymbol["Speaker"] = 137] = "Speaker";
    IconSymbol[IconSymbol["SpeakerHeadphone"] = 138] = "SpeakerHeadphone";
    IconSymbol[IconSymbol["Square"] = 139] = "Square";
    IconSymbol[IconSymbol["Stack"] = 140] = "Stack";
    IconSymbol[IconSymbol["Start"] = 141] = "Start";
    IconSymbol[IconSymbol["Stereo"] = 142] = "Stereo";
    IconSymbol[IconSymbol["Stop"] = 143] = "Stop";
    IconSymbol[IconSymbol["Subtract"] = 144] = "Subtract";
    IconSymbol[IconSymbol["Sun"] = 145] = "Sun";
    IconSymbol[IconSymbol["Swap"] = 146] = "Swap";
    IconSymbol[IconSymbol["System"] = 147] = "System";
    IconSymbol[IconSymbol["Table"] = 148] = "Table";
    IconSymbol[IconSymbol["Tape"] = 149] = "Tape";
    IconSymbol[IconSymbol["TapeReel"] = 150] = "TapeReel";
    IconSymbol[IconSymbol["Time"] = 151] = "Time";
    IconSymbol[IconSymbol["Timeline"] = 152] = "Timeline";
    IconSymbol[IconSymbol["Tone3000"] = 153] = "Tone3000";
    IconSymbol[IconSymbol["Tool"] = 154] = "Tool";
    IconSymbol[IconSymbol["Triangle"] = 155] = "Triangle";
    IconSymbol[IconSymbol["Undo"] = 156] = "Undo";
    IconSymbol[IconSymbol["Unknown"] = 157] = "Unknown";
    IconSymbol[IconSymbol["UserFolder"] = 158] = "UserFolder";
    IconSymbol[IconSymbol["Velocity"] = 159] = "Velocity";
    IconSymbol[IconSymbol["Vinyl"] = 160] = "Vinyl";
    IconSymbol[IconSymbol["Vocoder"] = 161] = "Vocoder";
    IconSymbol[IconSymbol["Volume"] = 162] = "Volume";
    IconSymbol[IconSymbol["VUMeter"] = 163] = "VUMeter";
    IconSymbol[IconSymbol["Warning"] = 164] = "Warning";
    IconSymbol[IconSymbol["Waveform"] = 165] = "Waveform";
    IconSymbol[IconSymbol["Zeitgeist"] = 166] = "Zeitgeist";
})(IconSymbol || (IconSymbol = {}));
(function (IconSymbol) {
    IconSymbol.toName = (symbol) => IconSymbol[symbol];
    IconSymbol.fromName = (name) => IconSymbol[name] ?? IconSymbol.Rectangle;
})(IconSymbol || (IconSymbol = {}));
